import { useEffect, useState } from 'react';

import { IconTimesDefault } from '@iwoca/icons';
import { RootState } from '@iwProvider/configureStore';
import { connect } from 'react-redux';

import { useMediaQuery } from '../../customHooks/useMediaQuery';

const getEnvironmentLabel = () => {
    const hostname = window.location.hostname;

    if (hostname === 'localhost' || hostname === '127.0.0.1') {
        return 'Development';
    }

    if (hostname.includes('iwoca-dev')) {
        return 'Staging';
    }

    return 'Production';
};

const mapStateToProps = (state: RootState) => ({
    ...state.siteContext,
    showImpersonationBar: state.siteContext.impersonating
});

type PropsFromRedux = ReturnType<typeof mapStateToProps>;

function ImpersonationBar({
    showImpersonationBar,
    impersonatingStateKey,
    errorCode,
    errorDetail
}: PropsFromRedux) {
    const [isDismissed, setIsDismissed] = useState(false);
    const isVisible =
        !isDismissed && Boolean(errorCode || showImpersonationBar);
    const isDesktop = useMediaQuery('(min-width: 768px)');

    useEffect(() => {
        document.documentElement.style.setProperty(
            '--impersonation-bar-height',
            isVisible && isDesktop ? `30px` : '0px'
        );

        return () => {
            document.documentElement.style.setProperty(
                '--impersonation-bar-height',
                '0px'
            );
        };
    }, [isVisible, isDesktop]);

    if (!isVisible) return null;

    return (
        <div
            className="fixed top-0 z-[112] hidden h-[30px] w-full items-center overflow-hidden bg-core-65 text-s font-bold text-structure-100 min-m:flex"
            data-testid="impersonationBar"
        >
            <div className="flex grow items-center justify-center gap-s">
                <span>{getEnvironmentLabel()}</span>
                <span className="-mt-[2px] text-2xl opacity-50">&#8226;</span>
                <span>Impersonating state key: {impersonatingStateKey}</span>
                {errorCode && (
                    <small>
                        <strong>{errorCode}</strong> {errorDetail}
                    </small>
                )}
            </div>
            <button
                className="p-s hover:bg-core-40"
                onClick={() => setIsDismissed(true)}
            >
                <IconTimesDefault
                    fontSize="24px"
                    className="text-structure-100"
                />
            </button>
        </div>
    );
}

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps)(ImpersonationBar);
